export const ocplcModelTOFAuditTrial = `query GetModelTOFAuditTrial($filter: ModelTOFAuditTrialRequest!) {
    ocplcModelTOFAuditTrial(filter: $filter) {
      modelTOFAuditTrial {
        action
        version
        region
        country
        productGroup
        productFamily
        businessModel
        programType
        programs
        createDate
        startDate
        endDate
        comments
        status
        whoChanged
        lastModifiedDate
      }
    }
  }`

export const ocplcModelAvailabilityAuditTrial = `query ocplcModelAvailabilityAuditTrial($filter: ModelAuditAvailabilityRequest!) {
  ocplcModelAvailabilityAuditTrial(filter: $filter) {
    modelAuditTrial {
      action
      version
      region
      productGroup
      productFamily
      country
      businessModel
      createDate
      startDate
      endDate
      hStartDate
      hEndDate
      comments
      status
      whoChanged
      ap
      la
      eu
      na
      lastModifiedDate
    }
  }
}`

export const ocplcModelAvailabilityAuditTrialVersion = `query GetModelAvailabilityAuditTrial($filter: ModelAuditAvailabilityVersionRequest!) {
  ocplcModelAvailabilityAuditTrialVersion(filter: $filter) {
    modelAuditTrial {
      action
      version
      region
      productGroup
      productFamily
      country
      businessModel
      createDate
      startDate
      endDate
      hStartDate
      hEndDate
      comments
      status
      whoChanged
      ap
      eu
      la
      na
      lastModifiedDate
    }
  }
}`

export  const ocplcModelTOFAuditTrialVersion = `query GetModelTOFAuditTrialVersion($filter: ModelTOFAuditTrialVersionRequest!) {
  ocplcModelTOFAuditTrialVersion(filter: $filter) {
    modelTOFAuditTrial {
      action
      version
      region
      country
      productGroup
      productFamily
      businessModel
      programType
      programs
      createDate
      startDate
      endDate
      comments
      status
      whoChanged
      lastModifiedDate
    }
  }
}`

export const materialAvailabilityTOFAudit = `query GetMaterialAvailabilityTOFAudit($filter: MaterialAvailabilityTOFAuditRequest!) {
  materialAvailabilityTOFAudit(filter: $filter) {
    tof{
    action
    version
    region
    country
    businessGroup
    productGroup
    productFamily
    businessModel
    material
    programType
    programs
    localization
    choiceId
    createDate
    startDate
    endDate
    comments
    status
    whoChanged
    lastModifiedDate
  }
  }
}`
export const materialAvailabilityAuditV2 =`query MaterialAvailabilityAuditV2($filter: MaterialAvailabilityAuditV2Request!) {
  materialAvailabilityAuditV2(filter: $filter) {
    material {
      pkId
      action
      version
      region
      businessGroup
      productGroup
      productFamily
      material
      country
      businessModel
      localization
      choiceId
      startDate
      endDate
      comments
      status
      ap
      eu
      na
      la
      regionLock
      logicalLock
      whoChanged
      createDate
      lastModifiedDate
      keyOrder
    }
  }
}`
export const materialAvailabilityAudit = `query GetMaterialAvailabilityAudit($filter: MaterialAvailabilityAuditRequest!) {
  materialAvailabilityAudit(filter: $filter) {
    material {
      pkId
      action
      version
      region
      businessGroup
      productGroup
      productFamily
      material
      country
      businessModel
      localization
      choiceId
      startDate
      endDate
      comments
      status
      ap
      eu
      na
      la
      regionLock
      logicalLock
      whoChanged
      createDate
      lastModifiedDate
      keyOrder
    }
  }
}`

export const serviceAvailabilityAudit = `query GetServiceAvailabilityAudit($filter: ServiceAvailabilityAuditRequest!) {
  serviceAvailabilityAudit(filter: $filter) {
    services {
      pkId
      version
      region
      businessGroup
      productGroup
      productFamily
      material
      country
      businessModel
      localization
      choiceId
      startDate
      endDate
      hStartDate
      hEndDate
      comments
      status
      ap
      eu
      na
      la
      regionLock
      logicalLock
      whoChanged
      createDate
      lastModifiedDate
      keyOrder
    }
  }
}`

export const servicesAuditV3 = `query ServicesAuditV3($filter: ServicesAuditV3Request!) {
  servicesAuditV3(filter: $filter) {
    V3resp {
      pkId
      action
      version
      region
      country
      businessGroup
      productGroup
      productFamily
      material
      businessModel
      choiceId
      startDate
      endDate
      hStartDate
      hEndDate
      comments
      status
      ap
      eu
      la
      na
      regionLock
      whoChanged
      createDate
      lastModifiedDate
      keyOrder
    }
  }
}`

export const parametersAudit=`query ParametersAudit($filter: ParametersAuditRequest!) {
  parametersAudit(filter: $filter) {
    paramaterAudits {
      pkId
      action
      version
      region
      businessGroup
      productGroup
      productFamily
      country
      feature
      featureValue
      text
      comments
      status
      whoChanged
      createDate
      lastModifiedDate
    }
  }
}`
export const localizationDefaultAudit=`query LocalizationDefaultAudit($filter: DefaultLocAuditRequest!) {
  localizationDefaultAudit(filter: $filter) {
    defaultLocAudit {
      pKId
      version
      region
      businessGroup
      productGroup
      productFamily
      country
      locFeature
      locFeatureValue
      feature
      featureValue
      comments
      status
      whoChanged
      createDate
      lastModifiedDate
    }
  }
}`
 export const localizationAvailabilityAudit=`query LocalizationAvailabilityAudit($filter: LocalizationAuditRequest!) {
  localizationAvailabilityAudit(filter: $filter) {
    localizations {
      pkId
      action
      version
      region
      businessGroup
      productGroup
      productFamily
      feature
      featureValue
      country
      category
      startDate
      endDate
      comments
      status
      apRegion
      euRegion
      naRegion
      laRegion
      whoChanged
      createDate
      lastModifiedDate
      keyOrder
    }
  }
}`